import { colors } from "src/assets";
import React from "react";
import { View } from "react-native";
import { Icon } from "src/components";
import { useRootNotificationsUnreadCount } from "src/hooks";

export type MyPageTabIconProps = {
  color: string;
};

export const MyPageTabIcon: React.FC<MyPageTabIconProps> = ({ color }) => {
  const [count] = useRootNotificationsUnreadCount();
  return (
    <View>
      <Icon name="person" color={color} size={24} />
      {count > 0 && (
        <View
          style={{
            position: "absolute",
            top: 0,
            right: -10,
            width: 8,
            height: 8,
            borderRadius: 4,
            backgroundColor: colors.orange,
          }}
        />
      )}
    </View>
  );
};
